import { PATIENT_WAITING_LIST } from "@/api_framework/api_config";
import { IGroomerStaffListResponse } from "@/api_framework/api_modals/Configuration";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError } from "axios";
import { useCallback, useState } from "react";
import AxiosCurlirize from "axios-curlirize";

AxiosCurlirize(axios, () => {});

export const useCityGroomerStaffListAPI = () => {
  const configuration = useConfiguration();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const [groomerOptions, setGroomerOptions] = useState([]);

  const execute = useCallback(
    async (city_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        const response = await axios.get<IGroomerStaffListResponse>(
          `${PATIENT_WAITING_LIST.CITY_GROOMERS_LIST.baseURL}${city_id}/`,
          {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          },
        );
        if (response.data.data.length > 0) {
          setGroomerOptions(response.data.data);
        } else {
          setGroomerOptions([]);
        }
      } catch (error) {
        if (axios.isAxiosError(error)) {
          setGroomerOptions([]);
          const axiosError = error as AxiosError;
          captureError(axiosError);
          if (axiosError.config) {
            sendCurl(axiosError.config["curlCommand"]);
          }
        }
      }
    },
    [configuration],
  );

  return { execute, groomerOptions };
};
